var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g(_vm._b({ref:"button",tag:"component",staticClass:"\n        inline-flex justify-center items-center\n        focus:z-10\n    ",class:[_vm.classNames, {
        'pointer-events-none select-none': _vm.loading,
        'cursor-not-allowed opacity-75': _vm.disabled,
        'w-full': _vm.wFull,
    }],attrs:{"disabled":_vm.disabled,"tag":"a","to":_vm.to,"type":_vm.type}},'component',_vm.$attrs,false),_vm.buttonListeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }